module.exports = __webpack_public_path__ + "img/symbol_17_free.902e6164.png";